import { render, staticRenderFns } from "./AreaAddUpdate.vue?vue&type=template&id=f13748e8&scoped=true"
import script from "./AreaAddUpdate.vue?vue&type=script&lang=js"
export * from "./AreaAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./AreaAddUpdate.vue?vue&type=style&index=0&id=f13748e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13748e8",
  null
  
)

export default component.exports